import { fetchBankInfor, fetchProductTypes, fetchProductTable } from '@/api/road'

const state = {
  tableParams: {
    pageNo: 1,
    pageSize: 10,
    total: 0
  },
  tableData: []
}
const mutations = {
  SET_TABLE_PARAMS: (state, param) => {
    state.tableParams = {
      ...state.tableParams,
      ...param
    }
  },
  SET_TABLE_DATA: (state, tableData) => {
    state.tableData = tableData
  }
}

const actions = {
  // 获取全省市区列表（树）
  async fetchBankInfor({ commit }, params) {
    return fetchBankInfor(params)
  },
  async fetchProductTypes({ commit }, params) {
    return fetchProductTypes(params)
  },
  async fetchProductTable({ commit }, params) {
    return fetchProductTable(params)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
